// VideoDeleteConfirmModal Component
// Confirmation modal for deleting videos

import React from 'react';
import { RevoltModal } from '../../../components/RevoltModal';
import { RevoltButton } from '../../../components/RevoltButton';
import './VideoDeleteConfirmModal.css';

export function VideoDeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  video = null, // { id: string, name: string }
  isLoading = false
}) {
  if (!video) {
    return null;
  }

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    } else {
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Video"
      showCloseButton={true}
    >
      <div className="video-delete-confirm-content">
        <p className="video-delete-confirm-message">
          Are you sure you want to delete the video "{video.name}"? This action cannot be undone.
        </p>
        <div className="video-delete-confirm-actions">
          <RevoltButton
            variant="outline"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="danger"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                Deleting...
              </>
            ) : (
              'Delete Video'
            )}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default VideoDeleteConfirmModal;